import { render, staticRenderFns } from "./CustomError.vue?vue&type=template&id=bc18521c"
import script from "./CustomError.vue?vue&type=script&lang=js"
export * from "./CustomError.vue?vue&type=script&lang=js"
import style0 from "./CustomError.vue?vue&type=style&index=0&id=bc18521c&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports